/* eslint-disable import/prefer-default-export */
/**
 * In-memory store for the double-submit CSRF token.
 *
 * The XSRF-TOKEN cookie is now HttpOnly and scoped to the API path (/api/v1), so it can no
 * longer be read from JavaScript. The API returns the token value in the authenticate/login
 * response body; we keep the latest value here and the axios interceptors echo it in the
 * X-CSRF-Token / X-XSRF-TOKEN request headers (AVIT2608824 - Cookie Security: Overly Broad Path).
 *
 * The value lives only in module memory, so it is cleared automatically on a full page reload
 * or tab close.
 */

let inMemoryCsrfToken = null

/**
 * Stores the latest CSRF token. No-op when passed an empty value so an unrelated response
 * cannot wipe a valid token.
 * @param {string} token
 */
export const setCsrfToken = token => {
  if (token) {
    inMemoryCsrfToken = token
  }
}

/**
 * @returns {string|null} the current in-memory CSRF token, or null if none has been stored.
 */
export const getCsrfToken = () => inMemoryCsrfToken

/**
 * Clears the stored CSRF token (call on logout / session clear).
 */
export const clearCsrfToken = () => {
  inMemoryCsrfToken = null
}
